module.exports = __webpack_public_path__ + "img/DSC_0065.0dd6b37c.jpg";